import { render, staticRenderFns } from "./MaterialDurationList.vue?vue&type=template&id=f84334f8&scoped=true"
import script from "./MaterialDurationList.vue?vue&type=script&lang=js"
export * from "./MaterialDurationList.vue?vue&type=script&lang=js"
import style0 from "./MaterialDurationList.vue?vue&type=style&index=0&id=f84334f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84334f8",
  null
  
)

export default component.exports